// Verifica ambiente por host da API configurada no .env. para mostrar mensagem de ambiente de test/treinamento
const HOMOLOG_API_HOST = 'api.siapen.sejus.pi.gov.br';
const PRODUCTION_API_HOST = 'producao.sejus.pi.gov.br';
const DEFAULT_PRODUCTION_SYSTEM_URL = 'https://sigepen.sejus.pi.gov.br/';

const getApiHost = () => {
  const rawApiBaseUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '';
  if (!rawApiBaseUrl) return '';

  try {
    return new URL(rawApiBaseUrl).host.toLowerCase();
  } catch (error) {
    return String(rawApiBaseUrl).toLowerCase();
  }
};

export const isTrainingEnvironment = () => {
  const host = getApiHost();
  if (host === HOMOLOG_API_HOST) {
    return true;
  }
  if (host === PRODUCTION_API_HOST) {
    return false;
  }
  return false;
};

export const getTrainingEnvironmentMessage = () => (
  isTrainingEnvironment() ? 'AMBIENTE DE TREINAMENTO E TESTES' : ''
);

export const getProductionSystemUrl = () => {
  if (!isTrainingEnvironment()) return '';
  return (process.env.REACT_APP_PRODUCTION_SYSTEM_URL || DEFAULT_PRODUCTION_SYSTEM_URL).trim();
};
